import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useUserLogged } from '../../hooks/useUserLogged';

export const useHome = (onLogout) => {
  const navigate = useNavigate();
  const { clearToken } = useAuth();
  const userLogged = useUserLogged();

  const handleLogout = useCallback(() => {
    clearToken();
    if (onLogout) onLogout();
    navigate('/');
  }, [clearToken, onLogout, navigate]);

  return {
    userLogged,
    handleLogout,
  };
};
